import { ApiError } from '@api'
import { isAxiosError } from 'axios'

import { DIALOG_TYPE } from '@/dialogs/constants'
import { markAsLoggedOutOF } from '@/models/chattingUI/OFauth'
import { $openedDialogs, openDialog } from '@/models/dialogs'

export const isOFLogoutError = (error: unknown) => {
  let status: number | undefined
  let errorMessage: string | undefined

  if (error instanceof ApiError) {
    errorMessage = error.body.detail
    status = error.status
  }

  if (isAxiosError<{ detail?: string }>(error) && error.response) {
    errorMessage = error.response.data.detail
    status = error.response.status
  }

  return (
    (status === 401 && errorMessage === 'Not logged in') ||
    (status === 500 &&
      ['Please login to OnlyFans first', 'Not logged in.'].some(
        (message) => message === errorMessage,
      ))
  )
}

export const handleOFLogout = () => {
  markAsLoggedOutOF()
  // eslint-disable-next-line effector/no-getState
  const isLoggedOutOfDialogOpen = $openedDialogs
    .getState()
    .some(
      (dialog) => dialog.type === DIALOG_TYPE.LOGGED_OUT_OF && dialog.isOpen,
    )

  if (!isLoggedOutOfDialogOpen) {
    openDialog({
      type: DIALOG_TYPE.LOGGED_OUT_OF,
      isPersistent: true,
    })
  }
}
